import { createPixiText } from '../../../Utils/Utils';

export class InviteBox extends PIXI.Sprite {
    constructor(tabWidth: number) {
        super();

        const rect = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/leaderboard-playertag-bg']);
        rect.anchor.set(0.5);
        // rect.x = this.containerWidth / 2;
        // rect.y = this.containerHeight * 0.12 + this.playerContainers.length * rect.height * 1.1;
        const giftIcon = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/leaderboard-invite-gift']);
        giftIcon.anchor.set(0.5);
        giftIcon.x = -tabWidth * 0.35;
        giftIcon.y = -rect.height * 0.05;
        const waitingText = createPixiText(
            'Waiting for friend to join...',
            new PIXI.Rectangle(
                tabWidth * 0.1,
                rect.y - rect.height * 0.05,
                rect.width * 0.7,
                rect.height
            ),
            'Baloo',
            30,
            28
        );
        waitingText.anchor.set(0.5);

        this.addChild(rect, giftIcon, waitingText);

        this.scale.set(0);
        this.pivot.x = rect.width / 2;
        // this.x = this.containerWidth * 0.48;
        this.pivot.y = 0;
    }
}
